import { ABAC } from '../primary-record-types';
import { getIntl } from './intl';

const intl = getIntl('utils.permissions', {
    view: 'View',
    edit: 'Edit',
    denied: 'None',
});

const getEachValue = (permissions: ABAC.AppPermissions): ABAC.ViewEditPermissions[] => {
    return Object.values(permissions);
};

export const hasView = (permissions: ABAC.AppPermissions): boolean => {
    return getEachValue(permissions).includes('view');
};

export const hasEdit = (permissions: ABAC.AppPermissions): boolean => {
    return getEachValue(permissions).includes('edit');
};

export const completelyRestrictedPermissions: ABAC.AppPermissions = {
    idsAndInfo: 'denied',
    medications: 'denied',
    conditions: 'denied',
    allergies: 'denied',
    careTeam: 'denied',
    visits: 'denied',
    patientPortals: 'denied',
    cloudCalendars: 'denied',
    settings: 'denied',
    reports: 'denied',
    files: 'denied',
    imaging: 'denied',
    procedures: 'denied',
    vaccinations: 'denied',
    labs: 'denied',
    collaborators: 'denied',
};

export const getPermissionsDescription = (appPermissions: ABAC.AppPermissions): string => {
    const permissions: string[] = [];
    if (hasView(appPermissions)) {
        permissions.push(intl('view'));
    }

    if (hasEdit(appPermissions)) {
        permissions.push(intl('edit'));
    }

    if (permissions.length === 0) {
        permissions.push(intl('denied'));
    }

    return permissions.join(', ');
};
